import React from 'react';
import NoMarginH4 from '../common/NoMarginH4';
import { DEFAULT_SECTIONS_LIST } from '../types';
import { useSitrepSectionWizardContext } from '../SitrepSectionWizardContext';
import StylishNewSelect from '../../../DesignSystems/New/StylishNewSelect';
import { StylishNewRadio } from 'components/DesignSystems/New/StylishNewRadio';
import StylishNewInput from '../../../DesignSystems/New/StylishNewInput';
import { useSectionTemplates } from '../../../DisasterGPT/hooks/useSectionTemplates';
import { useHighSecurityFlag } from '../../../../utils/featureFlags';
/**
 * First step of the Sitrep Section Wizard. This component displays the default
 * sections for a SITREP, along with the ability to create custom sections.
 */

type Option = {
  label: string;
  value: string;
};

const SectionTemplates = () => {
  const { sectionName, setSectionName } = useSitrepSectionWizardContext();
  const [defaultSelectValue, setDefaultSelectValue] = React.useState<Option>();
  const [customOption, setCustomOption] =
    React.useState<string>('ai-summarized');
  const { data: customOptions = [] } = useSectionTemplates();
  const highSecurityFlag = useHighSecurityFlag();

  const filteredDefaultSections = highSecurityFlag
    ? DEFAULT_SECTIONS_LIST.filter((section) => section !== 'News (ai)')
    : DEFAULT_SECTIONS_LIST;

  const filteredTemplates = [...filteredDefaultSections, ...customOptions];

  return (
    <div className="d-flex flex-column gap-3">
      <NoMarginH4>Select Section Template</NoMarginH4>
      <StylishNewSelect
        className="dark-background-button"
        onChange={(e: Option) => {
          setDefaultSelectValue(e);
          setSectionName(e?.value);
          setCustomOption('');
        }}
        value={defaultSelectValue}
        options={filteredTemplates.map((section) => {
          if (typeof section === 'string') {
            return {
              value: section,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <span>{section}</span>
                  <span>(Default)</span>
                </div>
              ),
            };
          } else {
            return {
              value: section.name,
              label: section.name,
            };
          }
        })}
        isClearable={true}
      />
      <h6>OR</h6>
      <div>
        <NoMarginH4>Create New Custom Template</NoMarginH4>
      </div>
      <StylishNewRadio
        disabled={false}
        id={'ai-summarized'}
        name={'ai-summarized'}
        value={1}
        className={`my-3`}
        key={1}
        label={'AI Summarized'}
        onChange={() => {
          setCustomOption('ai-summarized');
          setSectionName('');
        }}
        checked={customOption === 'ai-summarized'}
      />
      <StylishNewRadio
        disabled={false}
        id={'manual-entry'}
        name={'manual-entry'}
        value={2}
        className={`my-3`}
        key={2}
        label={'Manual Entry'}
        onChange={() => {
          setCustomOption('manual-entry');
        }}
        checked={customOption === 'manual-entry'}
      />
      {customOption === 'manual-entry' && (
        <StylishNewInput
          value={sectionName}
          placeholder="Enter Section Name"
          onChange={(e: any) => {
            setSectionName(e.target.value);
          }}
        />
      )}
    </div>
  );
};

export default SectionTemplates;
